const showQuestion = (question, bAnswers, qAnswers, pAnswers, customParameters = null) => {
  if (!question) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(question, 'visible')) {
    return false;
  }

  if (typeof question.visible === 'boolean') {
    return question.visible;
  }

  if (typeof question.visible === 'function') {
    return question.visible(bAnswers, qAnswers, pAnswers, customParameters);
  }

  return false;
};

export default showQuestion;
